import React, { useEffect, useState } from "react";
import Context from "../context";
import Slider from "./Slider";
import './test.css'
import Texts from "./Texts";
import TestQuestion from "./TestQuestion";

export default function TestBlockLogic({block, changeAllAnswers, isPassed, changeResult,slideNumber,setRightObject}) {

  const [answers, setAnswers] = React.useState([])
  const [isRightObj, setIsRightObj] = React.useState({}) //??? Could I delete this ???

  let isRightOobj = {}
  let userQuestionScores = {}

  useEffect(() => {
      changeAllAnswers(answers, block.id)
  }, [answers])

  useEffect(() => {
    if (isPassed) {
      sendTest()
    }
  }, [isPassed])
  useEffect(()=>{
    if(isPassed) {
      setRightObject(isRightObj)
  }

},[isRightObj])

  function changeIsRightAnswers(id, percents) {
    let item = Math.round(percents) === 100 ? 1 : percents <= 0 ? 0 : 2

    setIsRightObj(isRightObj => {
      return {
        ...isRightObj,
        [id]:item,
      }
    })

    isRightOobj = {
      ...isRightOobj,
      [id]:item,
    }
  }

  function countQuestionScore(questionAnswers, userAnswers) {
    let userPercents = 0;
    let userAnswersList = []

    for (let key in userAnswers){
      if (userAnswers[key]) {
        userAnswersList.push(key === 'value' ? userAnswers[key] : key)
      }
    }

    questionAnswers.forEach(item => {
      userPercents += userAnswersList.includes(item.name) ? +item.percent : 0
    })

    return userPercents > 0 ? userPercents : 0;

  }

  function getResult(test, answers) {

    let userScore = 0;
    test.questions.map((question) => {

      let userPercent = 0;

      if (question.type === 1 || question.type === 4) {
        userPercent = countQuestionScore(question.answers, answers[question.number])
      }

      if(question.type === 2){
        const userAnswers = answers[question.number]
        const parameter = question.answers[0]?.parameter?.isAllCheck ||false; // получение параметра должны ли быть все ответы введены
        if(parameter){
          let error = false;
          question.answers.forEach(item=>{
           if(+item.percent>0 && !error){
             error = !userAnswers[item.name]
           }
          })
          userPercent = !error ? 100 : 0;
        }
        else{
          userPercent = countQuestionScore(question.answers, userAnswers)
        }
      }

      if (question.type === 5 ) {
        let oneAnswerPercents = 100 / question.answers.length
        question.answers.map(item => {
          userPercent += answers[question.number][item.name] === item.equal ? oneAnswerPercents : 0
        })
      }
        //Проверить, работает ли
      if (question.type === 6) {
        let questionAnswer = question.answers.filter((item,k)=>{
          if(k%2!==0)
            return item
      });

        let oneAnswerPercent = 100 / questionAnswer.length

        questionAnswer.map((item,i) => {
          if( answers[question.number].value?.[i]!== undefined)
              if(item.replace(/ /g,'').toUpperCase() === answers[question.number].value[i].replace(/ /g,'').toUpperCase() ) {
                userPercent += oneAnswerPercent
              }
        })
      }


      if (question.type === 7) {
        let isError = false
        let oneAnswerPercents = 100 / question.answers.length

        question.answers.map((item,i) => {
          if(item === answers[question.number].value[i] && !isError) {
            userPercent += oneAnswerPercents
          } else {
            isError = true
          }
        })
      }

      if (question.type === 9) {
        let questionAnswer = question.answers.filter((item,k)=>{
          if(k%2!==0)
            return item
        });

        let oneAnswerPercent = 100 / questionAnswer.length
        questionAnswer.map((item,i) => {
            if(item === answers[question.number]?.[i]) {
              userPercent += oneAnswerPercent
            }
        })
      }
      if (question.type === 10) {
        const arrValid=[]
        question.answers.forEach((row,rowCount)=>{
          row.forEach((cell,cellCount)=>{
            if(typeof cell==='boolean' && cell===true){
              arrValid.push(!!answers?.[question.number]?.[rowCount]?.[cellCount])
            }
          })
        })
        for(let i = 1; i< question.answers.length;i++){
          if(arrValid[i-1]){
            userPercent += Number(question.answers[i][0].percent)
          }
        }
      }
      if (question.type === 11) {
        const data = [...question?.answers];
        const props=data.pop();
        const textPercent = props.text.replace(/ /g,'').toUpperCase()===answers[question.number]?.text?.replace(/ /g,'').toUpperCase()? (100-Number(props.percent)):0;
        let answerPercent = 0;

        answers[question.number]?.answers?.forEach((answer) => {
          data.forEach((itemAnswer) => {
            if (itemAnswer.name === answer) {
              answerPercent += Number(itemAnswer.percent);
            }
          });
        });

        userPercent = textPercent+(Number(props.percent)*answerPercent/100);
      }

      userScore += Math.round(question.score * userPercent/100)
      changeIsRightAnswers(question.number, userPercent + (question.type === 3 || question.type === 8? 1 : 0))
      userQuestionScores = {
          ...userQuestionScores,
          [question.number]: Math.round(question.score * userPercent/100)
        }
    })

    changeResult(userScore, block.id, isRightOobj, userQuestionScores)
    return userScore;
  }

  function sendTest() {
    getResult(block, answers)
  }

  function writeAnswers(response) {
    setAnswers(answers => {
      return {
        ...answers,
        ...response,
      }
    })
  }

  let tasks = block?.questions && block?.questions.map((question) => {
    return (
      <TestQuestion key={question.id} question={question} length={block.questions.length} writeAnswers={writeAnswers} isPassed={isPassed}/>
    )
  })

  return (
    <Context.Provider value={{answers, changeIsRightAnswers}}>
      <div className="test__block  " >
          <div className="test">
            <Slider key={block.id}
                    data={tasks}
                    haveTexts={!!block?.texts.length}
                    texts={<Texts texts={block?.texts}/>}
                    slideNumber={slideNumber}
            />
          </div>
      </div>
    </Context.Provider>
  )
}
